import { createGetTextResources } from "adviesbox-shared";

export const getDossierbalkTextResources = createGetTextResources({
    "downloadError": "Er is iets fout gegaan tijdens het downloaden van het dossier."
});